<template>
  <section class="vorteile">
    <div class="partners-and-trustpilot container">
      <div class="row">
        <div class="col-xs col-lg-12">
          <div class="inner-wrap">
            <div class="trustpilot">
              <span>Das sagen unsere Kunden:</span>
              <div class="google-rating-widget">
                  <a href="https://www.google.com/search?q=PKW.de+Digital+Mobility+Solutions+GmbH%2C+Hansaallee+299%2C+40549+D%C3%BCsseldorf%2C+Deutschland#lrd=0x47b8b6774c6145d5:0x857e72330821615c,1,,,," target="_blank">
                    <img src="../assets/google-rating.png" alt="Google Bewertungen" />
                  </a>
              </div>
              <div class="rating-widget">
                <div ref="rating"></div>
              </div>
            </div>
            <div class="divider"></div>
            <div class="partners">
              <span>Bekannt aus: </span>
              <a href="https://www.prosieben.de/" target="_blank" class="partner-logo partner-logo01">
                <img src="../assets/pro7.png" alt="Pro7" />
              </a>
              <a href="https://www.rtl.de/" target="_blank" class="partner-logo partner-logo02">
                <img src="../assets/rtl.png" alt="RTL" />
              </a>
              <a href="https://www.rtl2.de/" target="_blank" class="partner-logo partner-logo03">
                <img src="../assets/rtlzwei.png" alt="RTLZwei" />
              </a>
              <a href="https://www.sport1.de/" target="_blank" class="partner-logo partner-logo04">
                  <img src="../assets/sport1.png" alt="Sport1" />
                </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Vorteile",
  mounted() {
    var s = document.createElement('script');
    var options = {id: 3536};
    s.async = true;
    s.onload = function () {
        getWidget('https://meinebewertungen.pkw.de', '/de', 'kY7Y2P', s, options);
    };
    s.src = 'https://meinebewertungen.pkw.de/js/widget.js';
    this.$refs.rating.appendChild(s);
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/vars";

.vorteile {
  text-align:center;

  @include breakpoint(fromgiant) {
    text-align:left;
  }
}

.vorteile-container {
  background: $red;
  box-shadow: inset -60px 30px 99px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;

  @include breakpoint(fromgiant) {
    background: transparent;
    box-shadow: none;
    border-radius: 0;
  }
}
.vorteile-block {
  color: $white;
  padding-left: 18px;
  padding-right: 18px;
  padding-top: 15px;
  padding-bottom: 12px;
  position: relative;

  @include breakpoint(frommediumlarge) {
      padding-top: 45px;
      padding-bottom: 22px;
  }

  @include breakpoint(fromgiant) {
    padding-left: 47%;
    
    background: $red;
    box-shadow: inset -60px 30px 99px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px;

    &:before {
      content: "";
      display: block;
      width: 550px;
      height: 516px;
      background-image: url("../assets/driver-hand.png");
      background-size: cover;
      background-position: center;
      position: absolute;
      bottom: 0;
      left: -10px;
    }
  }

  @include breakpoint(extralarge) {
      padding-left: 46%;
      padding-top: 80px;
        padding-bottom: 97px;

    &:before {
        width: 600px;
        height: 563px;
    }
  }

  @include breakpoint(full) {
      &:before {
        width: 676px;
        height: 634px;
    }
  }

  .vorteile-title {
    font-size: 30px;
    line-height: 50px;
    font-weight: 600;
    margin-bottom: 14px;

    @include breakpoint(frommediumlarge) {
        font-size: 40px;
        line-height: 91px;
    }

    @include breakpoint(fromgiant) {
      font-size: 60px;
      margin-bottom: 31px;
    }
  }

  .vorteile-list {
    padding: 0;
    li {
      position: relative;
      font-size: 26px;
      line-height: 36px;
      margin-bottom: 14px;
      padding-left: 36px;

      @include breakpoint(frommediumlarge) {
        margin-bottom: 34px;
      }

      &:before {
        content: "";
        display: block;
        width: 24px;
        height: 19px;
        background-image: url("../assets/check-white.svg");
        position: absolute;
        left: 0;
        top: 8px;
      }
    }
  }
}

.partners-and-trustpilot {
  .inner-wrap {
    
    padding-top: 25px;
    padding-bottom: 25px;

    @include breakpoint(frommediumlarge) {
        padding-top: 45px;
        padding-bottom: 50px;
        
    }

    @include breakpoint(fromgiant) {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 85px;
        padding-bottom: 100px;
    }

    .partners {
      display: flex;
      flex-wrap:wrap;
      justify-content: center;
        align-items: center;
        margin-bottom:20px;
        margin-top:40px;


      @include breakpoint(fromgiant) {
        margin-top:0;
        padding-left:30px;
        justify-content: flex-start;
      }

      @include breakpoint(extralarge) {
        width:33%;
      }

      @include breakpoint(full) {
        padding-left:0;
      }

      span {
        font-size: 25px;
        line-height: 30px;
        font-weight: 600;
        width:100%;
        display:block;
        margin-bottom:20px;

        @include breakpoint(frommediumlarge) {
            font-size: 30px;
            line-height: 50px;
        }

        @include breakpoint(fromlarge) {
            font-size: 25px;
            line-height: 30px;
        }

        @include breakpoint(fromgiant) {
            font-size: 30px;
            line-height: 50px;
        }

        @include breakpoint(extralarge) {
          margin-right: 50px;
        }
      }

      a {
        img {
          display: block;
        }

        &.partner-logo {
          &.partner-logo01 {
            img {
              width:49px;
            }
          }

          &.partner-logo02 {
            img {
              width:152px;
            }
          }

          &.partner-logo03 {
            img {
              width:65px;
            }
          }
        }

        &:not(:last-of-type) {
          margin-right: 25px;
          margin-bottom:20px;

          @include breakpoint(frommediumlarge) {
            margin-bottom:0;
          }

          @include breakpoint(fromgiant) {
            margin-right:10px;
          }

          @include breakpoint(full) {
            margin-right: 40px;
          }
        }
      }
    }

    .divider {
      display:none;

      @include breakpoint(fromgiant) {
          display:block;
          height: 132px;
        width: 1px;
        background: $border-dark;
      }
    }

    .trustpilot {
      
      font-size: 25px;
      line-height: 30px;
      font-weight: bold;
      display: flex;
      flex-direction: column;
        align-items: center;
        justify-content:center;
        flex-wrap:wrap;

      @include breakpoint(frommediumlarge) {
        flex-direction: row;
        flex-wrap:wrap;
        font-size: 30px;
        line-height: 50px;
        justify-content: center;
      }

      @include breakpoint(fromlarge) {
            
            font-size: 25px;
          line-height: 30px;
          white-space: nowrap;
          
      }

      @include breakpoint(fromgiant) {
        justify-content: space-between;
        padding-right:25px;
      }

      @include breakpoint(extralarge) {
        font-size: 30px;
        line-height: 50px;
        width: 40%;
      }

      @include breakpoint(full) {
        width: 58%;
      }

      span {
        display:block;
        width:100%;
        font-weight: 600;
        margin-bottom:20px;
      }

      .google-rating-widget {
        margin-bottom:20px;

        @include breakpoint(frommediumlarge) {
          margin-bottom:0;
          margin-right:20px;
        }
        @include breakpoint(fromgiant) {
            margin-right:0;
          }

        img {
          @include breakpoint(frommediumlarge) {
            width:190px;
          }
          @include breakpoint(fromgiant) {
            width:200px;
          }
          @include breakpoint(extralarge) {
            width:auto;
          }
        }
      }

      .trustpilot-widget {
          @media screen and (min-width:481px) {
            margin-top:15px;
          }

          @include breakpoint(frommediumlarge) {
              margin-top:0;
              margin-left:10px;
          }

          @include breakpoint(fromgiant) {
            margin-left:0;
          }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/local-components/Vorteile.vue